require('../../modules/es.object.assign');

module.exports = require('../../internals/path').Object.assign;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/es/object/assign.js
// module id = 188
// module chunks = 0